import { H3 } from '@codex/basics';
import { translations } from '@codex/helpers';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@codex/icons';

const StatusWrapper = styled.div`
  display: flex;
  color: ${({ theme, status }) => (status.positive
    ? theme.colors.buy.default
    : theme.colors.alert.default
  )};
  
  ${Icon} {
    margin-top: -4px;
    width: 22px;
    height: 22px;
    flex-shrink: 0;
  }
  
  ${H3} {
    color: currentColor;
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    line-height: 1.1;
  }
`;

const StatusLabel = props => (
  <StatusWrapper status={props.status}>
    <Icon icon="Tick" />
    <H3 data-qa={props.dataQa}>{translations[props.status.tag]}</H3>
  </StatusWrapper>
);

StatusLabel.propTypes = {
  dataQa: PropTypes.string,
  status: PropTypes.shape({
    tag: PropTypes.string,
    positive: PropTypes.bool
  }).isRequired
};

StatusLabel.defaultProps = {
  dataQa: undefined
};

export default StatusLabel;
